import { useQuery } from "react-query";
import queryString from "query-string";
import URL from "core/resources/urls";
import http from "infra/http";

function useGetMatrizOperacoes(
  talhaoIds: string[],
  classeOperacao: string[],
) {
  const talhaoIdsKey = [...talhaoIds].sort();
  const classeOperacaoKey = [...classeOperacao].sort();

  return useQuery(
    [URL.ORDEM_SERVICO.TALHOES, talhaoIdsKey, classeOperacaoKey],
    async () => {
      const { data } = await http.get(URL.ORDEM_SERVICO.TALHOES, {
        params: {
          talhaoIds,
          operacaoClasseIds: classeOperacao,
        },
        paramsSerializer: params => queryString.stringify(params, { arrayFormat: "none" }),
      });
      return data;
    },
    {
      enabled: talhaoIds.length >= 0 || classeOperacao.length >= 0,
    }
  );
}

export default useGetMatrizOperacoes;
